import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Typography, Button } from '@hmsexp/component-library';
import { View, TouchableOpacity, Image } from '../Common/react-native-components';
import ROUTE_CONSTANTS from '../../AppRoutes/RouteConstants';
import styles from './styles';
import brandLogo from './brand.png';
import { isRNWebView } from '../../utils/isRNWebView';
import WebViewTabs from './WebViewTabs';
import DownloadReportButton from './DownloadReportButton';

const NavigationBar = ({signOut}) => {
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const isWebView = isRNWebView();

  // Check if device is mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);
  
  const navItems = [
    { id: 1, title: 'Overview', path: ROUTE_CONSTANTS.OVERVIEW },
    { id: 2, title: 'Online Review', path: ROUTE_CONSTANTS.ONLINE_REVIEW },
    { id: 3, title: 'Feedback', path: ROUTE_CONSTANTS.FEEDBACK },
    { id: 4, title: 'Alerts', path: ROUTE_CONSTANTS.ALERTS },
    { id: 5, title: 'Room Ranker', path: ROUTE_CONSTANTS.ROOM_RANKER },
    { id: 6, title: 'AI Analytics', path: ROUTE_CONSTANTS.AI_INSIGHTS }
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavItemPress = (path) => {
    history.push(path);
    setIsMobileMenuOpen(false); // Close mobile menu after navigation
  };

  const renderLogo = () => {
    return (
      <TouchableOpacity
        onPress={() => history.push(ROUTE_CONSTANTS.DASHBOARD)}
        style={styles.logoContainer}
      >
        <Image
          source={brandLogo}
          style={styles.logoImage}
          resizeMode="contain"
        />
      </TouchableOpacity>
    );
  };

  const renderNavItem = (item, isMobile = false) => {
    const isHovered = hoveredItemId === item.id;
    const isActive = location.pathname === item.path;
    const handlePress = () => {
      handleNavItemPress(item.path);
    };
    
    return (
      <TouchableOpacity
        key={item.id}
        style={[
          isMobile ? styles.mobileNavItem : styles.navItem,
          isActive ? (isMobile ? styles.mobileNavItemActive : styles.navItemActive) : styles.navItemInactive,
          isHovered && !isActive && !isMobile ? styles.navItemHover : {}
        ]}
        onMouseEnter={() => !isMobile && setHoveredItemId(item.id)}
        onMouseLeave={() => !isMobile && setHoveredItemId(null)}
        onPress={handlePress}
        activeOpacity={0.7}
      >
        <Typography
          variant="subtitle1"
          color='white'
          style={[
            isMobile ? styles.mobileNavText : styles.navText,
            isActive ? styles.navTextActive : {},
            isHovered && !isActive && !isMobile ? styles.navTextHover : {}
          ]}
        >
          {item.title}
        </Typography>
      </TouchableOpacity>
    );
  };

  const renderHamburgerIcon = () => {
    return (
      <TouchableOpacity
        onPress={toggleMobileMenu}
        style={styles.hamburgerButton}
      >
        <View style={styles.hamburgerLine} />
        <View style={styles.hamburgerLine} />
        <View style={styles.hamburgerLine} />
      </TouchableOpacity>
    );
  };
  if (isWebView) {
    return <WebViewTabs navItems={navItems} />;
  }
  return (
    <View style={styles.navbar}>
      <View style={styles.navContainer}>
        {/* Left side: Logo */}
        <View style={styles.leftContainer}>
          {renderLogo()}
        </View>
        
        {/* Desktop Navigation - hidden on mobile */}
        {!isMobile && (
          <View style={styles.desktopNavContainer}>
            <View style={styles.navItemsContainer}>
              {navItems.map(item => renderNavItem(item, false))}
            </View>
            <View style={styles.actionsContainer}>
              <DownloadReportButton />
              <View style={styles.signOutContainer}>
                <Button 
                  size='medium'
                  title='Sign Out' 
                  onClick={() => signOut({history})}
                  style={styles.signOutButton}
                />
              </View>
            </View>
          </View>
        )}
        
        {/* Mobile Hamburger Menu */}
        {isMobile && (
          <View style={styles.mobileMenuContainer}>
            {renderHamburgerIcon()}
          </View>
        )}
      </View>
      
      {/* Mobile Navigation Menu */}
      {isMobileMenuOpen && (
        <View style={styles.mobileMenu}>
          {navItems.map(item => renderNavItem(item, true))}
          <View style={styles.mobileSignOutContainer}>
            <Button 
              size='medium'
              title='Sign Out' 
              onClick={() => {
                signOut({history});
                setIsMobileMenuOpen(false);
              }}
              style={styles.mobileSignOutButton}
            />
          </View>
        </View>
      )}
    </View>
  );
};

export default NavigationBar;